<template>
  <div class="button__controls">
    <ArrowButton reverse :disabled="min === current" @click="$emit('decrease')"/>
    <ArrowButton :disabled="max === current" @click="$emit('increase')"/>
  </div>
</template>

<script>
import {ArrowButton} from '@/components/small'

export default {
  name: 'ButtonControls',
  components: {ArrowButton},
  props: {
    current: {
      type: Number,
      required: true
    },
    max: {
      type: Number,
      required: true
    },
    min: {
      type: Number,
      default: 0
    }
  },
  emits: ['decrease', 'increase']
}
</script>